import PDF from "../website-behaviors/PDF.js";
import {
	generateProQuestCitation,
	PN_PROQUEST_DETAILS_URL_REQUEST,
	PN_PROQUEST_DETAILS_URL_RESPONSE
} from "./ProQuest.js";
import {waitUntil} from "../utils/async.js";

class ProQuestPdf extends PDF {
	identifier() {
		return "ProQuestPdf";
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'location' implicitly has an 'any' type.
	static test(location) {
		return location.host === "media.proquest.com";
	}

	shouldFrameTakeControl() {
		return true;
	}

	async generateStructuredCitation() {
		// @ts-expect-error FIXME
		let url;

		// See ProQuest.js for the other end of message handling
		// @ts-expect-error FIXME
		window.top.postMessage({type: PN_PROQUEST_DETAILS_URL_REQUEST}, "*");
		window.addEventListener("message", (evt) => {
			if (evt.data.type === PN_PROQUEST_DETAILS_URL_RESPONSE)
				url = evt.data.url;
		});

		// @ts-expect-error FIXME
		await waitUntil(() => url !== undefined);

		return generateProQuestCitation(url);
	}
}

export default ProQuestPdf;
